<template>
    <CCard class="order-rd-card">
        <CCardHeader>
            <strong>Доставка еды</strong> <small>Подробности заказа</small>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Карточка" class="pt-1">
                    <div class="flex items-center my-2">
                        <span class="w-1/3">Приборы</span>
                        <span class="w-2/3">{{ orderUnmodified.cutlery }}</span>
                    </div>
                    <div v-if="shownCalories">
                        <span>КБЖУ: {{ all_weight }} грамм / {{ all_calories }} ккал / {{ formatMacro(all_protein) }} белки / {{ formatMacro(all_fat) }} жиры / {{ formatMacro(all_carbohydrates) }} углеводы</span>
                        <br>
                    </div>
                    <CDataTable
                        hover
                        :items="enabledUnmodifiedItems"
                        :fields="unmodifiedFields"
                    >
                        <template #restaurant="data">
                            <td>
                                <CLink
                                    v-if="data.item.restaurant && data.item.restaurant.id"
                                    :to="`/restaurants/${data.item.restaurant.id}`"
                                >{{ data.item.restaurant.title }}</CLink>
                                <span v-else>—</span>
                            </td>
                        </template>

                        <template #dish="data">
                            <td :class="{ 'green': !data.item.not_added, 'red': data.item.removed }">
                                <CLink

                                    :to="`/restaurants/${data.item.restaurant.id}/dishes/${data.item.dish.id}`"
                                >
                                    <b style="font-size: 120%">{{ data.item.dish_title ? data.item.dish_title : data.item.dish.title }}</b>
                                    <!-- <span v-if="data.item.modifiers.length || data.item.ingredients.length"> : </span> -->
                                </CLink>
                                <div>
                                    <div v-if="data.item.modifiers && data.item.modifiers.length" class='indent'>
                                        <span style="font-weight: 700">Модификаторы: </span><br>
                                        <span
                                            v-for="modifier in data.item.modifiers" 
                                            :key="`modifier-${modifier.id}-${modifier.group_id}`"
                                        >
                                            <span v-if="modifier.group_title">
                                                <span style="font-weight: 600">{{ modifier.group_title }}: </span> 
                                                <span style="font-size: 105%">{{ modifier.title }} - {{ formatPrice(modifier.price) }}</span><br>
                                            </span>
                                            <span v-else>
                                                <span style="font-weight: 600">На выбор: </span> 
                                                <span style="font-size: 105%">{{ modifier.title }} - {{ formatPrice(modifier.price) }}</span><br>
                                            </span>
                                            <!-- <span v-if="modifier.old_price">(<span class="old-price">{{ formatPrice(modifier.old_price) }}</span>)</span> -->
                                        </span>
                                    </div>
                                    <div v-if="data.item.ingredients && data.item.ingredients.length">
                                        <span style="font-weight: 700">Ингредиенты: </span><br>
                                        <span
                                            v-for="ingredient in data.item.ingredients"
                                            :key="`ingredient-${ingredient.id}-${ingredient.group_id}`"
                                        >
                                            <span v-if="ingredient.group_title">
                                                <span style="font-weight: 600">{{ ingredient.group_title }}: </span>
                                                <span style="font-size: 105%">{{ getIngrQuantity(ingredient) }}x {{ ingredient.title }} - {{ formatPrice(ingredient.price) }}</span><br>
                                            </span>
                                            <span v-else>
                                                <span style="font-weight: 600">Добавить: </span>
                                                <span style="font-size: 105%">{{ getIngrQuantity(ingredient) }}x {{ ingredient.title }} - {{ formatPrice(ingredient.price) }}</span><br>
                                            </span>

                                            <!-- <span v-if="ingredient.old_price">(<span class="old-price">{{ formatPrice(ingredient.old_price) }}</span>)</span> -->
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </template>


                        <template #price="data">
                            <td>
                                {{ formatPrice(data.item.price) }}
                                <span v-if="(data.item.promotion_id === null)&& (data.item.price && data.item.old_price && +data.item.price != +data.item.old_price)">
                                    <span class="old-price">({{ formatPrice(data.item.old_price) }})</span>
                                </span>
                                <span v-if="(data.item.promotion_id !== null) && (data.item.price && data.item.old_dish_price && +data.item.price != +data.item.old_dish_price)">
                                    <span class="old-price">({{ formatPrice(data.item.old_dish_price) }})</span>
                                </span>
                            </td>
                        </template>
                        
                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #price_total="data">
                            <td v-if="order.promotion !== null" :class="{'red': data.item.not_added && (data.item.price != data.item.price_total), 'green': !data.item.not_added}">
                                {{ formatPrice(data.item.price_total) }}
                                <span v-if="data.item.price_total && data.item.old_price_total && +data.item.price_total != +data.item.old_price_total">
                                    <span class="old-price">({{ formatPrice(data.item.old_price_total) }})</span>
                                </span>
                            </td>
                            <td v-if="order.promotion === null" :class="{'red': data.item.not_added && (data.item.price != data.item.price_total), 'green': !data.item.not_added}">
                                {{ formatPrice(data.item.price_total) }}
                                <span v-if="data.item.price_total && data.item.old_dish_price && +data.item.price_total != +data.item.old_dish_price">
                                    <span class="old-price">({{ formatPrice(data.item.old_dish_price) }})</span>
                                </span>
                            </td>
                        </template>

                        <template #quantity_total="data">
                            <td
                                :style="+data.item.quantity_total > 1 ? 'font-size: 200%' : ''"
                                :class="{'red': data.item.not_added && (data.item.quantity != data.item.quantity_total), 'green': !data.item.not_added}">
                                {{ data.item.quantity_total }}
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #sum="data">
                            <td>
                                {{ formatPriceForSum(data.item) }}
                            </td>
                        </template>
                        
                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice(data.item.sum_total) }}
                            </td>
                        </template>

                        <template #edit> </template>
                    </CDataTable>
                </CTab>
                <CTab title="Редактировать" class="pt-1">
                    <CRow>
                        <CCol sm="4" class="form-group pt-1">Приборы</CCol>
                        <CCol sm="8" class="form-group">
                            <CInput
                                v-model="order.cutlery"
                                class="m-0"
                                type="number"
                            />
                        </CCol>
                    </CRow>

                    <CDataTable
                        hover
                        :items="enabledItems"
                        :fields="fields">
                        <template #restaurant="data">
                            <td>
                                <CLink
                                    :to="`/restaurants/${data.item.restaurant.id}`"
                                >
                                    {{ data.item.restaurant.title }}
                                </CLink>
                            </td>
                        </template>

                        <template #dish="data">
                            <td>
                                <CLink

                                    :to="`/restaurants/${data.item.restaurant.id}/dishes/${data.item.dish.id}`"
                                >
                                    <b>{{ data.item.dish_title ? data.item.dish_title : data.item.dish.title }}</b>
                                </CLink>
                                <span v-if="(data.item.modifiers && data.item.modifiers.length) || (data.item.ingredients && data.item.ingredients.length)">:<br /></span>
                                <span
                                    v-for="modifier in data.item.modifiers"
                                    :key="`modifier-${modifier.id}-${modifier.group_id}`"
                                >
                                    {{ modifier.title }} - {{ formatPrice(modifier.price) }}<br />
                                    <!-- <span v-if="modifier.old_price">(<span class="old-price">{{ formatPrice(modifier.old_price) }}</span>)</span> -->
                                </span>
                                <span
                                    v-for="ingredient in data.item.ingredients"
                                    :key="`ingredient-${ingredient.id}-${ingredient.group_id}`"
                                >
                                     {{ getIngrQuantity(ingredient) }}x {{ ingredient.title }} - {{ formatPrice(ingredient.price) }}<br />
                                    <!-- <span v-if="ingredient.old_price">(<span class="old-price">{{ formatPrice(ingredient.old_price) }}</span>)</span> -->
                                </span>
                            </td>
                        </template>

                        <!-- <template #dish_price="data">
                            <td>{{ +data.item.dish_price }} р.</td>
                        </template> -->

                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice((data.item.price * data.item.quantity) - data.item.refund_sum) }}
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #edit="data">
                            <td>
                                <CButton
                                    v-if="data.item.dish_id"
                                    variant="ghost"
                                    color="primary"
                                    class="mb-1"
                                    @click="itemEdit(data.item)"
                                >
                                    <CIcon name="cil-pencil" /> </CButton
                                    ><br />
                                <CButton
                                    variant="ghost"
                                    color="danger"
                                    @click="itemDelete(data.item.id)"
                                >
                                    <CIcon name="cil-trash" />
                                </CButton>
                            </td>
                        </template>
                    </CDataTable>
                    <CRow>
                        <CCol class="form-group text-right">
                            <CButton
                                color="light"
                                class="ml-3"
                                @click="inactiveItemAdd"
                            >Добавить из неактивного</CButton
>
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="itemAdd"
                            >Добавить блюдо</CButton
                            >
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol class="form-group">
                            <CButton
                                color="primary"
                                class="mr-3"
                                @click="orderUpdate"
                            >Сохранить</CButton
                            >
                            <CButton
                                color="light"
                                class="mr-3"
                                @click="$emit('cancel')"
                            >Отмена</CButton
                            >
                        </CCol>
                    </CRow>
                </CTab>
            </CTabs>
        </CCardBody>

        <OrderRDItemEdit
            :modal="itemEditModal"
            @update="itemUpdate"
            @cancel="itemCancel"
        />
        <OrderRDItemInactiveEdit
            :modal="inactiveItemEditModal"
            @update="inactivetemUpdate"
            @cancel="inactiveItemCancel"
        />
    </CCard>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    import OrderRDItemEdit from './OrderRDItemEdit';
    import OrderRDItemInactiveEdit from './OrderRDItemInactiveEdit.vue';
    import Vue from 'vue';

    export default {
        name: 'OrderRD',

        components: {
            OrderRDItemEdit,
            OrderRDItemInactiveEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            orderUnmodified: {
                type: Object,
                default: () => ({}),
            },
            isShopOrder: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isAuthorized: false,
                fields: [
                    {
                        key: 'restaurant',
                        label: 'Ресторан',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'dish', label: 'Блюдо' },
                    { key: 'quantity', label: 'Кол-во' },
                    // { key: 'dish_price', label: 'Цена блюда' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'sum_total', label: 'Цена итоговая' },
                    { key: 'edit', label: '' },
                ],
                itemEditModal: {
                    item: {},
                    visible: false,
                    emptyItem: {
                        restaurant: {},
                        dish: {},
                        modifiers: [],
                        ingredients: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                        enabled: true,
                        applyDiscount: true,
                        active: true,
                    },
                },
                inactiveItemEditModal: {
                    item: {},
                    visible: false,
                    emptyItem: {
                        restaurant: {},
                        dish: {},
                        modifiers: [],
                        ingredients: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                        enabled: true,
                        applyDiscount: true,
                        inactive: true,
                    },
                },
                logDetails: [],
                logItems: {},
                logItem: {},

                all_carbohydrates: 0,
                all_fat: 0,
                all_protein: 0, 
                all_weight: 0,
                all_calories: 0,
                shownCalories: false,
            };
        },

        computed: {
            unmodifiedFields() {
                const fields = [
                    { key: 'dish', label: 'Блюдо' },
                    { key: 'quantity_total', label: 'Кол-во итог' },
                    { key: 'sum_total', label: 'Сумма итог' },
                    { key: 'price_total', label: 'Цена итог' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'quantity', label: 'Кол-во до' },
                    { key: 'sum', label: 'Сумма до' },
                    { key: 'price', label: 'Цена до' },
                ];
                if (this.isShopOrder) {
                    fields.unshift({
                        key: 'restaurant',
                        label: 'Ресторан',
                        _classes: 'font-weight-bold',
                    });
                }
                return fields;
            },
            enabledItems() {
                return this.order.items ? this.order.items.filter(item => {
                    return item.enabled
                }) : [];
            },
            enabledUnmodifiedItems() {
                if(this.orderUnmodified.items) {
                    const orderItems = this.orderUnmodified.items.map(item => {
                        const modifiers = Array.isArray(item.modifiers) ? item.modifiers : [];
                        const ingredients = Array.isArray(item.ingredients) ? item.ingredients : [];
                        return {
                            ...item,
                            modifiers,
                            ingredients,
                            unique_id: item.dish_id + modifiers.reduce((modifier_unique, modifier) => {
                                return modifier_unique + modifier.id;
                            }, '') + ingredients.reduce((ingredient_unique, ingredient) => {
                                return ingredient_unique + ingredient.id;
                            }, '')
                        };
                    });
                    const enabled = orderItems.map(item => {
                        return {
                            ...item,
                            price: +item.price,
                            old_price: +item.old_price,
                            quantity_total: item.quantity,
                            price_total: +item.price,
                            old_price_total: +item.old_price,
                            old_dish_price: +item.old_dish_price,
                            sum_total: item.sum,
                        }
                    }).filter(item => item.enabled);
                    const disabled = orderItems.filter(item => !item.enabled);
                    for(let i=0; i < enabled.length; i++) {
                        for(let j=0; j < disabled.length; j++) {
                            if(enabled[i].unique_id === disabled[j].unique_id && !disabled[j].checked) {
                                enabled[i].not_added = true;
                                enabled[i].quantity = disabled[j].quantity;
                                enabled[i].price = disabled[j].price;
                                enabled[i].old_price = disabled[j].old_price;
                                enabled[i].sum = disabled[j].sum;
                                disabled[j].not_removed = true;
                                disabled[j].checked = true;
                            }
                        }
                    }
                    for(let j=0; j < disabled.length; j++) {
                        if(!disabled[j].not_removed) {
                            disabled[j].not_added = true;
                            disabled[j].removed = true;
                            disabled[j].quantity_total = 0;
                            disabled[j].price_total = 0;
                            disabled[j].sum_total = 0;
                            enabled.push(disabled[j]);
                        }
                    }
                    for(let i=0; i < enabled.length; i++) {
                        if(!enabled[i].not_added) {
                            enabled[i].quantity = 0;
                            enabled[i].price = 0;
                            enabled[i].sum = 0;
                        }
                        enabled[i].sum = enabled[i].quantity * enabled[i].price;
                        enabled[i].sum_total = enabled[i].quantity_total * enabled[i].price_total - enabled[i].refund_sum;
                    }

                    return enabled;
                }
                return [];
            },
        },

        watch: {},

        mounted() {
            Vue.axios
                .get('/orders/' + this.order.order_id + '/logs')
                .then(resp => {
                    if (resp.data.length) {
                        const delta = [null, ...resp.data.map(log => log.delta)] || new Array(8).fill(null);
                        this.logItems = resp.data.map((log, i) => ({ ...log, delta: delta[i] }));
                        for (let i = 0 ; i < this.logItems.length; i++) {
                            if (this.logItems[i].payload && this.logItems[i].payload.iikoOrder) {
                                this.logDetails.push(this.logItems[i]);
                            }
                        }
                    } else {
                        this.logItems = [];
                    }
                })
                .catch(err => {
                    console.log(err);
                });

            this.calculateIngridientAndModifiedCalories();
        },

        methods: {
            formatMacro(value) {
                const n = Number(value);
                if (!Number.isFinite(n)) return '0.0';
                return (Math.round((n + Number.EPSILON) * 10) / 10).toFixed(1);
            },
            calculateIngridientAndModifiedCalories() {
                if (!this.order?.items[0]?.restaurant?.counting_calories) return;

                const multipleIngredients = this.order?.items[0]?.restaurant?.multiple_ingridients || false;
                let itemsCalories = 0;
                let itemsCarbohydrates = 0;
                let itemsFat = 0;
                let itemsWeight = 0;
                let itemsProtein = 0;

                for (let item of this.order?.items) {
                    if (item?.removed) continue;
                    if (!item?.enabled) continue;

                    const itemQuantity = item?.quantity > 0 ? item?.quantity : 1; 

                    let allCalories = item?.dish?.calories || 0;
                    let allCarbohydrates = item?.dish?.carbohydrates || 0;
                    let allFat = item?.dish?.fat || 0;
                    let allWeight = item?.dish?.weight || 0;
                    let allProtein = item?.dish?.protein || 0;

                    const ingredients = item?.ingredients || []; 
                    const modifiers = item?.modifiers || [];

                    if (ingredients?.length > 0) {
                        for (const ingridient of ingredients) {
                            if (!!multipleIngredients && ingridient?.quantity > 0) {
                                allCalories = ingridient?.calories ? allCalories + (ingridient?.calories * ingridient?.quantity) : allCalories;
                                allCarbohydrates = ingridient?.carbohydrates ? allCarbohydrates + (ingridient?.carbohydrates * ingridient?.quantity) : allCarbohydrates;
                                allFat = ingridient?.fat ? allFat + (ingridient?.fat * ingridient?.quantity) : allFat;
                                allWeight = ingridient?.weight ? allWeight + (ingridient?.weight * ingridient?.quantity) : allWeight;
                                allProtein = ingridient?.protein ? allProtein + (ingridient?.protein * ingridient?.quantity) : allProtein;
                            } else {
                                allCalories = ingridient?.calories ? allCalories + ingridient?.calories : allCalories;
                                allCarbohydrates = ingridient?.carbohydrates ? allCarbohydrates + ingridient?.carbohydrates : allCarbohydrates;
                                allFat = ingridient?.fat ? allFat + ingridient?.fat : allFat;
                                allWeight = ingridient?.weight ? allWeight + ingridient?.weight : allWeight;
                                allProtein = ingridient?.protein ? allProtein + ingridient?.protein : allProtein;
                            }
                        }
                    }
                    if (modifiers?.length > 0) {
                        for (const modifier of modifiers) {
                            allCalories = modifier?.calories ? allCalories + modifier?.calories : allCalories;
                            allCarbohydrates = modifier?.carbohydrates ? allCarbohydrates + modifier?.carbohydrates : allCarbohydrates;
                            allFat = modifier?.fat ? allFat + modifier?.fat : allFat;
                            allWeight = modifier?.weight ? allWeight + modifier?.weight : allWeight;
                            allProtein = modifier?.protein ? allProtein + modifier?.protein : allProtein;
                        }
                    }
                    itemsCalories += allCalories * itemQuantity;
                    itemsCarbohydrates += allCarbohydrates * itemQuantity;
                    itemsFat += allFat * itemQuantity;
                    itemsWeight += allWeight * itemQuantity;
                    itemsProtein += allProtein * itemQuantity;
                    
                }

                this.all_calories = itemsCalories;
                this.all_carbohydrates = itemsCarbohydrates;
                this.all_fat = itemsFat;
                this.all_weight = itemsWeight;
                this.all_protein = itemsProtein;
                this.shownCalories = true;
            },
            getIngrQuantity(ingr) {
                return ingr.quantity > 0 ? ingr.quantity : 1
            },
            formatDate(date) {
                return formatDate(date);
            },
            formatPrice(price) {
                return (Math.round(price * 100) / 100).toFixed(2) + 'р.';
            },
            getIikoOrderItems() {
                const iikoOrder = this.logDetails[0] && this.logDetails[0].payload && this.logDetails[0].payload.iikoOrder;
                if (!iikoOrder) {
                    return [];
                }
                const items = iikoOrder.items || (iikoOrder.order && iikoOrder.order.items);
                return Array.isArray(items) ? items : [];
            },
            formatPriceForSum(item) {
                const fallback = (Math.round(+item.sum * 100) / 100).toFixed(2) + 'р.';
                const logItem = this.getIikoOrderItems().find(iikoItem =>
                    +item.unique_id === +iikoItem.code && +item.sum !== +iikoItem.sum
                );
                if (logItem) {
                    return (Math.round(+logItem.sum * 100) / 100).toFixed(2) + 'р.';
                }
                return fallback;
            },
            itemAdd() {
                this.itemEditModal.item = { ...this.itemEditModal.emptyItem, isNewPosition: true };
                this.itemEditModal.visible = true;
            },
            inactiveItemAdd() {
                this.inactiveItemEditModal.item = { ...this.inactiveItemEditModal.emptyItem, isNewPosition: true };
                this.inactiveItemEditModal.visible = true;
            },
            itemEdit(item) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === item.id) {
                        if (item.inactive || item.dish.enabled === false) {
                            this.inactiveItemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                            this.inactiveItemEditModal.visible = true;
                        } 
                        if (item.active || item.dish.enabled === true) {
                            this.itemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                            this.itemEditModal.visible = true;
                        }
                    }
                }
            },
            itemDelete(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.order.items.splice(i, 1);
                    }
                }
            },
            itemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.itemEditModal.item.id) {
                        items.push(this.itemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.itemEditModal.item.id) {
                    this.itemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.itemEditModal.item)));
                }
                this.order.items = items;
                this.itemCancel();
            },
            inactivetemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.inactiveItemEditModal.item.id) {
                        items.push(this.inactiveItemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.inactiveItemEditModal.item.id) {
                    this.inactiveItemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.inactiveItemEditModal.item)));
                }
                this.order.items = items;
                this.inactiveItemCancel();
            },
            itemCancel() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = false;
            },
            inactiveItemCancel() {
                this.inactiveItemEditModal.item = this.inactiveItemEditModal.emptyItem;
                this.inactiveItemEditModal.visible = false;
            },
            orderUpdate() {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id && this.order.items[i].id.toString().indexOf('temp-') >= 0) {
                        delete this.order.items[i].id;
                    }
                }
                this.$emit('update');
            },
        },
    };
</script>

<style>
.order-rd-card .table th,
.order-rd-card .table td {
    vertical-align: middle;
}
.order-rd-card .old-price {
    text-decoration: none;
    color: #a7a7a7;
}
.order-rd-card .green {
    /* color: #33d436 */
}
.order-rd-card .red {
    color: red
}
.order-rd-card .blue {
    color: blue;
}
.indent {
    margin-bottom: 0.4em;
}
</style>
